import { MinimalInfinitScrollingTable } from "../../../-components/infinit-scrolling-table/minimal-infinit-scrolling-table"
import { useProductionTableColumns } from "./use-production-table-columns"
import { ProductionDto } from "../../../../../@client/Theasoft_ApiServer_Productions"

interface Props {
  seasonIds: number[]
  searchString: string
  genreTreeNodes: string[]
  onClickRow: (production: ProductionDto) => void
}
export function MinimalProductionTable({
  seasonIds,
  searchString,
  genreTreeNodes,
  onClickRow,
}: Props) {
  const { baseColumns } = useProductionTableColumns()
  return (
    <MinimalInfinitScrollingTable
      url="/api/Production/GetList"
      partialInput={{ seasonIds, searchString, genreTreeNodes }}
      columnDefinitions={baseColumns}
      onClickRow={onClickRow}
    />
  )
}
